import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { AxiomLogo } from '../../element/AxiomLogo/AxiomLogo';
import { LayoutItem } from '../Layout/LayoutItem';
import { Layout } from '../Layout/Layout';
import { LayoutBleed } from '../LayoutBleed/LayoutBleed';
import { Visible } from '../Visible/Visible';

import {
  HeaderBlock,
  HeaderMenuBlock,
  HeaderMobileMenuButton,
} from './HeaderBarStyles';

export const HeaderBar = ({
  children,
  name,
  logoUrl = '/',
  hideNavigation = false,
}: {
  children?: React.ReactNode;
  name?: string;
  logoUrl?: string;
  hideNavigation?: boolean;
}) => {
  const breakpoints = useBreakpoint();
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
  useEffect(() => {
    if (breakpoints.isSmallScreen) {
      document.body.style.overflowY = mobileMenuIsOpen ? 'hidden' : 'initial';
    }
  }, [mobileMenuIsOpen]);

  return (
    <HeaderBlock data-test={name}>
      <LayoutBleed>
        <Layout position="middle">
          <LayoutItem fluid>
            <div className="text-align-middle">
              {hideNavigation ? (
                <AxiomLogo height="48px" name="NAVBARLOGO" />
              ) : (
                <Link to={logoUrl} data-test="LOGO">
                  <AxiomLogo height="48px" name="NAVBARLOGO" />
                </Link>
              )}
            </div>
          </LayoutItem>
          <LayoutItem>
            <Layout position="middle">
              {!!children && (
                <Visible only="smallScreen">
                  <HeaderMobileMenuButton
                    className={AttrsHelper.formatClassname(
                      mobileMenuIsOpen && 'mobile-menu-open'
                    )}
                    onClick={() => {
                      setMobileMenuIsOpen(!mobileMenuIsOpen);
                    }}
                  >
                    <span />
                  </HeaderMobileMenuButton>
                </Visible>
              )}
              <HeaderMenuBlock
                className={AttrsHelper.formatClassname(
                  mobileMenuIsOpen && 'mobile-menu-open'
                )}
              >
                {children}
              </HeaderMenuBlock>
            </Layout>
          </LayoutItem>
        </Layout>
      </LayoutBleed>
    </HeaderBlock>
  );
};
